import { Observable } from 'rxjs';
import { SafeUrl, SafeResourceUrl } from '@angular/platform-browser';

import { BarIcon } from '../shared/bar-icon.model';
/**
 * @deprecated Use BaasLinkOptions within &lt;baas-layout&gt; with OnPush change detection.
 * Represents a clickable BAR element.
 */
// NOTE that we use delegates to mimic computed properties.
export class BarLinkOptions {
    /** Content in link */
    content?: Observable<any> | Promise<any> | any | (() => any);
    /** Click or tap action event. */
    action?: (event?: any) => void | boolean | Promise<void>;
    /** Href */
    href?: string | (() => string) | SafeUrl | (() => SafeUrl) | SafeResourceUrl | (() => SafeResourceUrl);
    /** Router link */
    routerLink?: any[] | (() => any[]);
    /** Router url */
    routerUrl?: string | (() => string);
    /** Query params used by Router Link */
    queryParams?: object | (() => object);
    /** Fragment used by RouterLink, tabindex needs to be present on target element (-1, 0) */
    fragment?: string | (() => string);
    /** Disabled or enabled link */
    disabled?: boolean | (() => boolean);
    /** Hidden or visible link */
    hidden?: boolean | (() => boolean);
    /** Title aka tooltip */
    title?: string | (() => string);
    /** Class to be used on the tooltip (title field), being matTooltipClass */
    tooltipClass?: string | (() => string);
    handleElement?: (element) => void;
    /** Target (e.g. _blank) */
    target?: string;
    /** Css class */
    cssClass?: string | (() => string);
    /** Is external link? */
    external?: boolean;
    /** Icon for the link */
    icon?: BarIcon;
}
